const state = {
  refresh: false,
  isNewVisit: false, // 是否是新增回访记录
  clickSave: false, // 是否点击学生也保存按钮
  filterFiles: [], // 自定义搜索表单
  local: 'zh',
  menu: {},
  userinfo: {},
  messageAmount: null,
  socket: {
    isConnected: false,
    message: '',
  },
  im_notify: {},
  im_url: null,
  // 用于infoMenu，同步信息菜单
  syncInfo: {
    finished: false,
    linked: false,
    relation: [],
  },
  menuIndex: 'base',
  bubbleCount: 0,
};

export default state;
